/**
 * finixt-ui's SegmentedControl, safe inside a form.
 *
 * The package's segments are untyped buttons, which a form treats as submit
 * buttons, so switching a view inside a form submitted it. The wrapper
 * cancels the click's default action after the control has handled it; the
 * selection still changes, the form stays put.
 */
import type { MouseEvent } from 'react';

import {
  SegmentedControl as FinixtSegmentedControl,
  type SegmentedControlProps,
} from './finixt.js';

export type { SegmentedControlProps };

export function SegmentedControl(props: SegmentedControlProps) {
  return (
    <span style={{ display: 'contents' }} onClick={(event: MouseEvent) => event.preventDefault()}>
      <FinixtSegmentedControl {...props} />
    </span>
  );
}
